import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faUser } from '@fortawesome/pro-light-svg-icons'

import mapContactsAndUserObjects from 'functions/mapContactsAndUserObjects'

import FormField from 'components/forms/FormField'
import InputSearch from 'suitTheme/InputSearch'
import Link from 'suitTheme/Link'
import SidebarModal from 'modals/sidebar/SidebarModal'
import UserProfileImage from 'suitTheme/UserProfileImage'

const mapResults = (contacts) => {
  const results = {
    groups: [
      {
        key: 'agency',
        title: 'AGENCY',
        items: contacts
          .filter(c => c.type !== 'Contact')
          .map((contact) => {
            const image = contact.image || {}
            return {
              ...contact,
              iconLeft: (
                <UserProfileImage image={image} imageKey="square">
                  <FontAwesomeIcon icon={faUser} />
                </UserProfileImage>
              ),
              secondaryText: contact.mobile || 'No Mobile',
              text: contact.full_name,
              key: `User-${contact.id}`,
            }
          }),
      },
    ],
  }

  return results
}

const User = (props) => {
  const {
    imageSelectPayload: {
      callbacks: { selectEntity },
      images,
      selectedEntity,
    },
  } = props

  const { full_name, id, mobile_number } = selectedEntity
  const image = images[selectedEntity.image] || {}

  const users = useSelector(reduxState => reduxState.entities.users)

  const contacts = mapContactsAndUserObjects({}, users, images)

  return (
    <>
      <FormField direction="column" label="Search Users">
        <InputSearch
          callbacks={{ selectItem: item => selectEntity({ type: 'User', id: item.id }) }}
          closeOnSelect
          placeholder="Search by name"
          results={mapResults(contacts)}
          showOnFocus
        />
      </FormField>

      {!!selectedEntity.id && (
        <SidebarModal.User
          disableHover
          image={image}
          imageKey="thumb_url"
          key={id}
          subtitle={mobile_number}
          title={full_name}
        >
          <Link greyLink onClick={() => selectEntity({ type: 'User', id: 0 })} textProps={{ fontSize: 'small' }}>
            <FontAwesomeIcon icon={faTrashAlt} />
          </Link>
        </SidebarModal.User>
      )}
    </>
  )
}

User.propTypes = {
  imageSelectPayload: PropTypes.shape({
    callbacks: PropTypes.shape({
      selectEntity: PropTypes.func.isRequired,
    }).isRequired,
    images: PropTypes.object.isRequired,
    selectedEntity: PropTypes.object.isRequired,
    selectedEntityId: PropTypes.number.isRequired,
    selectedEntityType: PropTypes.string.isRequired,
  }).isRequired,
}

export default User
